// Dependencies
import React from 'react'

// Components
import { Navbar } from 'components/Navbar'
import { WhatsDoubts } from 'components/whatssapp'
import { Footer } from 'components/Footer'

// Types
import PropTypes from 'prop-types'

type Props = {
  children?: React.ReactNode
}

export const Layout = ({ children }: Props) => {
  return (
    <>
      <Navbar />
      {children}
      <WhatsDoubts />
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}
